import { render, staticRenderFns } from "./TransferProductsModal.vue?vue&type=template&id=c7fd24d6&"
import script from "./TransferProductsModal.vue?vue&type=script&lang=js&"
export * from "./TransferProductsModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports